import { render, staticRenderFns } from "./taskstatic.vue?vue&type=template&id=530c97e0&scoped=true&"
import script from "./taskstatic.vue?vue&type=script&lang=js&"
export * from "./taskstatic.vue?vue&type=script&lang=js&"
import style0 from "./taskstatic.vue?vue&type=style&index=0&id=530c97e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530c97e0",
  null
  
)

export default component.exports